export function StoryhealthLogo({ height = 32, className }: { height?: number; className?: string }) {
  return (
    <img
      src="https://cdn.prod.website-files.com/670e4ade75003c7364a3944d/6a4e2ef01a4746eed34bcd95_story%20health%20logo%20sans%20innovaccer%20black.svg"
      alt="Story Health by Innovaccer"
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      draggable={false}
    />
  )
}

export default StoryhealthLogo
